<template>
  <div
    class="flex flex-1 h-full justify-start flex-col m-0 bg-slate-25 dark:bg-slate-900 max-w-full"
  >
    <settings-header
      button-route="new"
      :icon="icon"
      :header-title="$t(headerTitle)"
      :show-count-key="showCountKey"
      :button-text="$t(headerButtonText)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      :show-new-button="showNewButton"
      :show-sidemenu-icon="showSidemenuIcon"
    >
      <template #right>
        <router-view name="header" />
      </template>
    </settings-header>
    <keep-alive v-if="keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else />
  </div>
</template>

<script>
/* eslint no-console: 0 */
import SettingsHeader from './SettingsHeader.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  components: {
    SettingsHeader,
  },
  mixins: [hasPermissionMixin],
  props: {
    headerTitle: { type: String, default: '' },
    showCountKey: { type: String, default: null },
    headerButtonText: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },
    newButtonRoutes: {
      type: Array,
      default: () => [],
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    currentPage() {
      return this.$store.state.route.name;
    },
    showNewButton() {
      if (this.currentPage === 'settings_inbox_list') {
        return (
          this.hasCreatePermission('Inbox') &&
          this.newButtonRoutes.length !== 0 &&
          !this.showBackButton
        );
      }
      if (this.currentPage === 'online_wa_templates_list') {
        return (
          this.hasCreatePermission('WhatsApp Templates') &&
          this.newButtonRoutes.length !== 0 &&
          !this.showBackButton
        );
      }
      if (this.currentPage === 'settings_teams_list') {
        return (
          this.hasCreatePermission('Teams') &&
          this.newButtonRoutes.length !== 0 &&
          !this.showBackButton
        );
      }
      return this.newButtonRoutes.length !== 0 && !this.showBackButton;
    },
  },
};
</script>
